import React from "react";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import TableLandingPage from "./app/Pages/Table/LandingPage";
import FoodLandingPage from "./app/Pages/Food/LandingPage";
import OrderLandingPage from "./app/Pages/Order/LandingPage";
import Login from "./app/Login/views/Login";
import LandingPage from "./app/Pages/Home/LandingPage";
import Register from "./app/Register/RegisterLandingPage";
import Profile from "./app/Login/views/Profile";
import RoomLandingPage from "./app/Pages/Room/LandingPage";
import GuestLandingPage from "./app/Pages/Guest/LandingPage";
import ReportLandingPage from "./app/Pages/reports/LandingPage";
import ReservationLandingPage from "./app/Pages/Reservation/LandingPage";
import ExpenseLandingPage from "./app/Pages/Expense/LandingPage";
import ExpenseCategoryLandingPage from "./app/Pages/ExpenseCategory/LandingPage";
import InventoryCategoryLandingPage from "./app/Pages/InventoryCategory/LandingPage";
import InventoryLandingPage from "./app/Pages/Inventory/LandingPage";

const PrivateRoute = () => {
  const isAuthenticated = localStorage.getItem("billing_app_token") ? true : false;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};


function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        <Route element={<PrivateRoute />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/table" element={<TableLandingPage />} />
          <Route path="/room" element={<RoomLandingPage />} />
          <Route path="/food" element={<FoodLandingPage />} />
          <Route path="/order" element={<OrderLandingPage />} />
          <Route path="/guest" element={<GuestLandingPage />} />
          <Route path="/reservation" element={<ReservationLandingPage />} />
          <Route path="/report" element={<ReportLandingPage />} />
          <Route path="/expense" element={<ExpenseLandingPage />} />
          <Route path="/expense-category" element={<ExpenseCategoryLandingPage />} />
          <Route path="/inventory-category" element={<InventoryCategoryLandingPage />} />
          <Route path="/inventory" element={<InventoryLandingPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
